import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import "./inventory.css";
import { InventoryContainer, InventoryNav, LatestInventoryContainer, Header, Footer, InventoryHelmet } from '../../components';
import { getCategoryFromSlugs } from '../../utils/urlPaths';


const Inventory = () => {
    const { category: urlCategory, subcategory: urlSubcategory } = useParams();
    const [inventoryData, setInventoryData] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [subCategoryName, setSubCategoryName] = useState('');
    const [showLatestInventory, setShowLatestInventory] = useState(true);

    // Load data from URL parameters on mount
    useEffect(() => {
        if (urlCategory && urlSubcategory) {
            const { category, subCategory } = getCategoryFromSlugs(urlCategory, urlSubcategory);

            if (!category || !subCategory) {
                return;
            }

            axios.get('https://ohp.rockycoastlabs.xyz/getInventory.php', {
                params: { category, subCategory }
            })
                .then(response => {
                    setInventoryData(response.data);
                    setCategoryName(category);
                    setSubCategoryName(subCategory);
                    setShowLatestInventory(false);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        }
    }, [urlCategory, urlSubcategory]);

    const handleNavItemSelect = (data, category, subCategory) => {
        setInventoryData(data);
        setCategoryName(category);
        setSubCategoryName(subCategory);
        setShowLatestInventory(false);
    };

    const handleLatestClick = () => {
        setShowLatestInventory(true); 
    };

    return (
        <div className='inventory'>
            <InventoryHelmet/>
            <Header />
            <InventoryNav onNavItemSelect={handleNavItemSelect} onLatestClick={handleLatestClick} />
            {showLatestInventory ? <LatestInventoryContainer /> 
            : <InventoryContainer inventoryData={inventoryData}
                category={categoryName}
                subCategory={subCategoryName}/>}
            <Footer />
        </div>
    )
}

export default Inventory
